export const CANCELATION_DELAY = 45;
